/* AppLayout — the shell (13-08): a sticky top (practice ribbon + app bar), then the page. */

.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.top {
  position: sticky;
  top: 0;
  z-index: 50;
}

.main {
  flex: 1;
  min-width: 0;
  outline: none;
}

.skip {
  position: absolute;
  left: 12px;
  top: -120px;
  z-index: 60;
  padding: 8px 14px;
  border-radius: var(--radius-full);
  background: var(--white);
  box-shadow: var(--shadow-md);
  font-size: 13.5px;
  font-weight: 600;
  color: var(--purple-dark);
}

.skip:focus {
  top: 10px;
  text-decoration: none;
}
